import { render } from "./CadastroPlanilhaTrechos.vue?vue&type=template&id=3814d20e"
import script from "./CadastroPlanilhaTrechos.vue?vue&type=script&lang=ts"
export * from "./CadastroPlanilhaTrechos.vue?vue&type=script&lang=ts"
script.render = render

export default script